export function megabytesToBytes(mb: number) {
    const oneMegabyteInBytes = 1024 * 1024;
    const fileSizeInBytes = mb * oneMegabyteInBytes;

    return fileSizeInBytes;
}
